<template>
  <modal
    name="download-campaign"
    :click-to-close="false"
    height="auto"
    :adaptive="true"
    :scrollable="true"
    width="90%"
    :max-width="900"
    :pivot-y="0.2"
    class="download-campaign-modal"
    @before-open="onBeforeOpen"
  >
    <Button class="close-button" @click="onCloseClick">
      <v-icon slot="icon-end" name="times" />
    </Button>

    <DownloadCampaign :campaign-id="campaignId" />
  </modal>
</template>

<script>
import DownloadCampaign from "@/components/Campaigns/DownloadCampaign/DownloadCampaign";

export default {
  name: "DownloadCampaignModal",
  components: { DownloadCampaign },
  data() {
    return {
      campaignId: "",
    };
  },
  methods: {
    onBeforeOpen(event) {
      const { campaignId } = event.params;

      this.campaignId = campaignId;
    },
    onCloseClick() {
      this.$modal.hide("download-campaign");
    },
  },
};
</script>

<style scoped>
.download-campaign-modal >>> .v--modal {
  @apply overflow-visible;
  padding: 0;
}
</style>
